import { connect } from 'react-redux';
import { getG1AndG2 } from 'redux/modules/taxonomy/selectors';
import { DropDownNavHidden } from './DropdownNavHidden';

export default connect(state => ({
  taxonomy: getG1AndG2(state),
}))(DropDownNavHidden);
